export default "__VITE_ASSET__DpTq06LV__"